import { Component, model, input, signal } from '@angular/core';
import { take, finalize, Observable } from 'rxjs';

@Component({
  selector: 'vb-lxp-switch',
  templateUrl: './vb-lxp-switch.component.html',
})
export class VbLxpSwitchComponent {
  checked = model<boolean>(false);

  saveFn = input<(value: boolean) => Observable<unknown> | null>(null);
  disabled = input<boolean>(false);
  leftLabel = input<string>('');
  rightLabel = input<string>('');

  private pending = signal(false);

  toggle(next: boolean) {
    if (this.disabled() || this.pending()) return;

    const save = this.saveFn();

    if (!save) {
      this.checked.set(next);
      return;
    }

    const previous = this.checked();
    this.checked.set(next);
    this.pending.set(true);

    save(next)
      .pipe(
        take(1),
        finalize(() => this.pending.set(false)),
      )
      .subscribe({
        error: () => {
          this.checked.set(previous);
        },
      });
  }
}
